import { render, staticRenderFns } from "./icon-text-info-cmp.vue?vue&type=template&id=ec81c4ea&scoped=true"
import script from "./icon-text-info-cmp.vue?vue&type=script&lang=js"
export * from "./icon-text-info-cmp.vue?vue&type=script&lang=js"
import style0 from "./icon-text-info-cmp.vue?vue&type=style&index=0&id=ec81c4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec81c4ea",
  null
  
)

export default component.exports